import {DEFAULT_DB_NAME,DEFAULT_DB_VERSION} from './defaultConfig.js';
export default{
    install(Vue){
        let indexedDB=window.indexedDB||window.mozIndexedDB||window.webkitIndexedDB||window.msIndexedDB;
        Vue.prototype.$canUseIndexedDB=!!indexedDB;
        if(indexedDB){
            const request = indexedDB.open(DEFAULT_DB_NAME, DEFAULT_DB_VERSION);
            request.onsuccess=event=>{
                console.log('数据库初始化');
            };
            request.onupgradeneeded=event=>{
                console.log('数据库初始化创建或更新');
                initDB(event.target.result);
            };
            request.onerror=event=>{
                console.log('数据库初始化失败');
            };
        }
    }
}
// IDBDatabase 实例  如数据库表有变化，初始化需要修改数据库版本号 触发onupgradeneeded事件
function initDB(db){
    let objectStoreNames=db.objectStoreNames;
    try{
        //用户表登录表
        if(!objectStoreNames.contains('users')){
            db.createObjectStore("users", {keyPath: "username"});
        }
        //任务表
        if(!objectStoreNames.contains('tasks')){
            const taskStore=db.createObjectStore("tasks", {keyPath: "uniqKey"});
            //创建索引
            taskStore.createIndex("userIdIndex",'userId', {unique: false});
            taskStore.createIndex("userStatusIndex",['userId','isDelected'], {unique: false});
            taskStore.createIndex("userTaskStatusIndex",['userId','taskId','isDelected'], {unique: false});
        }
        //花名册量体数据表
        if(!objectStoreNames.contains('rousterMeasureDatas')){
            const measureDataStore=db.createObjectStore("rousterMeasureDatas", {keyPath: "uniqKey"});
            measureDataStore.createIndex('userTaskVersionStatusIndex',['userId','taskId','version','isChange'],{unique: false});
        }
        //量体任务净体部位排序表
        if(!objectStoreNames.contains('taskPositionSorts')){
            db.createObjectStore("taskPositionSorts", {keyPath: "uniqKey"});
        }
        //日志表 uniqKey type time content ...
        if(!objectStoreNames.contains('log')){
            const logStore=db.createObjectStore("log", {keyPath: "uniqKey"});
            logStore.createIndex("userIndex",['userId',],{unique: false});
        }
    }catch(err){
        console.log('表初始化失败--->',err)
    }
}